import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { CommonService } from '../shared/services/common.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { HttpService } from '../shared/services/http.service';
import { MdDialog } from '@angular/material';
import { dialogComponent } from '../dialog/dialog.component';
import { FOCaddApproverComponent } from './foc-addApprover.component';

@Component({
  template: require('./foc-admin.component.html'),
  styles: [require('./foc-admin.component.scss')]
})
export class FocAdminComponent {

  dialogRef: any;
  userData: any;

  approverList: any[] = [];
  approverMailList: any[] = [];

  isFOC_Admin = false;
  isFOC_Approver = false;
  isFOC_HR = false;
  isFOC_Employee = false;
  focRole: string = null;


  canEdit = false;

  constructor(
    private router: Router,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private sessionHandler: SessionHandler,
    private http: HttpService,
    private dialog: MdDialog,
    private formBuilder: FormBuilder
  ) {

    if (!this.http.checkSession()) {
      this.http.showSessionError();
      return;
    }

    const loginStr = this.sessionHandler.getItem('loginData');
    this.userData = loginStr ? JSON.parse(loginStr) : {};
    const roles = this.userData.role ? this.userData.role : [];

    // DO NOT USE includes() — Angular 5 TS compiler does NOT support it
    this.isFOC_Admin = roles.indexOf('FOC_ADMINISTRATOR') !== -1;
    this.isFOC_Approver = roles.indexOf('FOC_APPROVER') !== -1;
    this.isFOC_HR = roles.indexOf('FOC_HR') !== -1;
    this.isFOC_Employee = roles.indexOf('FOC_EMPLOYEE') !== -1;

    if (this.isFOC_Admin) {
      this.focRole = 'FOC_ADMINISTRATOR';
    } else if (this.isFOC_Approver) {
      this.focRole = 'FOC_APPROVER';
    } else if (this.isFOC_HR) {
      this.focRole = 'FOC_HR';
    } else if (this.isFOC_Employee) {
      this.focRole = 'FOC_EMPLOYEE';
    }

    this.canEdit = this.isFOC_Admin || this.isFOC_Approver;

    const hasFOC_Access =
      this.isFOC_Admin ||
      this.isFOC_Approver ||
      this.isFOC_HR ||
      this.isFOC_Employee;

    if (!hasFOC_Access) {
      this.showUnauthorized();
      return;
    }

    this.loadData();
  }

  showUnauthorized() {
    const ref = this.dialog.open(dialogComponent, { disableClose: true });
    ref.componentInstance.msg = 'You are not authorized to access this page.';
    ref.afterClosed().subscribe(() => {
      this.router.navigateByUrl('/app/foc_dashboard');
    });
  }

  loadData() {
    this.getApproverMailList();
    this.getApproverMatrix();
  }

  getApproverMailList() {
    this.http.showLoader();
    this.http.getRequest('focApproverOperationsApi/v1/getApproverMailList')
      .subscribe(
        (res: any) => {
          this.approverMailList = (res && res.approverList) ? res.approverList : [];
          this.http.onEnd();
        },
        (err: any) => this.showError(err)
      );
  }

  getApproverMatrix() {
    this.http.showLoader();
    this.http.getRequest('focApproverOperationsApi/v1/approverList')
      .subscribe(
        (res: any) => {
          this.approverList = (res && res.approverList) ? res.approverList : [];
          this.http.onEnd();
        },
        (err: any) => this.showError(err)
      );
  }

  showError(err: any) {
    const ref = this.dialog.open(dialogComponent);
    ref.componentInstance.msg =
      (err && err.errorMessage) ||
      (err && err.responseMessage) ||
      'Something went wrong';

    this.http.onEnd();
  }

  addApproverDialog(
    action: string,
    soldTo: any,
    primaryApproverEmail?: string,
    additionalApproverEmail?: string,
    fromDate?: any,
    toDate?: any
  ) {
    const ref = this.dialog.open(FOCaddApproverComponent, { disableClose: true });

    ref.componentInstance.action = action;
    ref.componentInstance.sold_To = soldTo;
    ref.componentInstance.primaryApproverEmail = primaryApproverEmail;
    ref.componentInstance.approverMailList = this.approverMailList;

    if (action === 'edit' || action === 'delete') {
      ref.componentInstance.email = additionalApproverEmail;
      ref.componentInstance.fromDate = fromDate;
      ref.componentInstance.toDate = toDate;
    }

    ref.afterClosed().subscribe((result: string) => {
      if (!result) return;

      let msg = 'Additional approver added successfully';
      if (result === 'edit') msg = 'Additional approver updated successfully';
      if (result === 'delete') msg = 'Additional approver deleted successfully';

      const dlg = this.dialog.open(dialogComponent, { disableClose: true });
      dlg.componentInstance.msg = msg;

      dlg.afterClosed().subscribe(() => {
        this.loadData()
        this.getApproverMatrix();
      });
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/foc-admin/foc-admin.component.ts